var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flight.voli && _vm.show
    ? _c(
        "div",
        { staticClass: "item-volo-hotel-andata" },
        [
          _c("ul", [
            _c("li", [
              _c(
                "div",
                {
                  class:
                    (_vm.isDestinazione
                      ? "flight-dest-dep-icon"
                      : "flight-go-icon") +
                    " has-icon d-flex justify-content-between"
                },
                [
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.isDestinazione
                            ? _vm.destinationAirport
                            : _vm.departureAirport
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tools" }, [
                    _vm.showInfoIcon
                      ? _c(
                          "button",
                          {
                            staticClass: "btn info",
                            on: { click: _vm.onClickInfo }
                          },
                          [_c("div")]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.isDestinazione
                        ? _vm.destinationAirportSigla
                        : _vm.departureAirportSigla
                    ) +
                      " - " +
                      _vm._s(_vm.time)
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("ModalFlightDetail", {
            ref: "modalFlightDetail",
            attrs: { value: _vm.flight, selected: true }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04ee6347", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ee6347","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/itinerario/ItemVoloAndata.vue
// module id = null
// module chunks = 